import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from '../../components/layouts/DashboardLayout';
import { getCampaign } from '../../components/actions/campaign';
import Loader from '../../components/utils/Loader';

export default function Campaigns() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total,settotal] = useState([])
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const campaignsPerPage = 6;

  useEffect(() => {
    setLoading(true);
    const merchantCode = sessionStorage.getItem("code");
    getCampaign(merchantCode)
      .then((res) => {
        const companyList = res?.data?.camWiseReport || [];
        const totaldata = res?.data?.campReport
        settotal(totaldata)
        const sortedList = companyList.sort(
          (a, b) => new Date(b.create_date) - new Date(a.create_date)
        );

        const today = new Date();

        const updatedList = sortedList.map((campaign) => {
          const startDate = new Date(campaign.start_date);
          const endDate = new Date(campaign.end_date);

          let status = campaign.status;

          // ✅ Overwrite status with date conditions
          if (startDate > today) {
            status = "scheduled";
          } else if (endDate < today) {
            status = "ended";
          } else if (campaign.status === "1") {
            status = "1"; // active
          }

          return {
            ...campaign,
            status,
            pointsEarned: 0,
            participants: 0,
          };
        });

        setData(updatedList);
        setFilteredData(updatedList);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching campaigns:', error);
        setLoading(false);
      });
  }, []);

  const filteredCampaigns = filteredData.filter((campaign) => {
    const matchesSearch =
      campaign.rule_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      campaign.rule_description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter =
      filterStatus === 'all' || campaign.status === (filterStatus === 'active' ? '1' : filterStatus);
    return matchesSearch && matchesFilter;
  });

  // Pagination
  const indexOfLastCampaign = currentPage * campaignsPerPage;
  const indexOfFirstCampaign = indexOfLastCampaign - campaignsPerPage;
  const currentCampaigns = filteredCampaigns.slice(indexOfFirstCampaign, indexOfLastCampaign);
  const totalPages = Math.ceil(filteredCampaigns.length / campaignsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getStatusColor = (status) => {
    switch (status) {
      case '1':
        return 'bg-green-100 text-green-800 border border-green-200';
      case 'scheduled':
        return 'bg-blue-100 text-blue-800 border border-blue-200';
      case 'ended':
        return 'bg-gray-100 text-gray-800 border border-gray-200';
      default:
        return 'bg-gray-100 text-gray-800 border border-gray-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case '1':
        return 'ri-play-circle-fill';
      case 'scheduled':
        return 'ri-time-line';
      case 'ended':
        return 'ri-check-circle-fill';
      default:
        return 'ri-question-line';
    }
  };

  return (
    <DashboardLayout>
      <div className="min-h-screen bg-gray-50">
        {loading && <Loader />}
        <div className="px-4 sm:px-6 lg:px-8 py-8">
          {/* Header Section */}
          <div className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">Campaigns</h1>
              <p className="text-gray-600">
                Manage your loyalty campaigns and track their performance.
              </p>
            </div>
            <Link
              to="/campaigns/create"
              className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 py-3 rounded-xl hover:from-blue-700 hover:to-blue-800 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 font-semibold shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-add-line text-lg"></i>
              Create New Campaign
            </Link>
          </div>

          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center">
                  <i className="ri-play-circle-line text-xl text-white"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">
                    {filteredData.filter(c => c.status === '1').length}
                  </p>
                  <p className="text-sm text-gray-600">Active Campaigns</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                  <i className="ri-time-line text-xl text-white"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">
                    {filteredData.filter(c => c.status === 'scheduled').length}
                  </p>
                  <p className="text-sm text-gray-600">Scheduled</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-purple-600 rounded-xl flex items-center justify-center">
                  <i className="ri-user-line text-xl text-white"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">
                    {total?.[0]?.totalParticipate || 0}
                  </p>
                  <p className="text-sm text-gray-600">Total Participants</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-xl flex items-center justify-center">
                  <i className="ri-star-line text-xl text-white"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">
                    {total?.[0]?.totalEarn || 0}
                  </p>
                  <p className="text-sm text-gray-600">Points Earned</p>
                </div>
              </div>
            </div>
          </div>

          {/* Filters Section */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-8">
            <div className="flex flex-col lg:flex-row gap-4">
              <div className="flex-1">
                <div className="relative">
                  <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-lg"></i>
                  <input
                    type="text"
                    placeholder="Search campaigns by name or description..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:outline-none transition duration-200 bg-gray-50"
                  />
                </div>
              </div>
              
              <div className="flex gap-3">
                <div className="relative">
                  <select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    className="appearance-none bg-white border border-gray-300 rounded-xl px-4 py-3 pr-10 focus:ring-2 focus:ring-blue-500 focus:outline-none cursor-pointer min-w-[150px]"
                  >
                    <option value="all">All Status</option>
                    <option value="active">Active</option>
                    <option value="scheduled">Scheduled</option>
                    <option value="ended">Ended</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
                
                <button className="px-4 py-3 border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer flex items-center gap-2">
                  <i className="ri-filter-line text-gray-600"></i>
                  <span className="text-gray-700 hidden sm:inline">More Filters</span>
                </button>
              </div>
            </div>
          </div>

          {/* Campaigns Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
            {currentCampaigns.map((campaign) => (
              <div
                key={campaign.rule_code}
                className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300 group"
              >
                <div className="relative">
                  <img
                    src={campaign.campaignImageUrl}
                    alt={campaign.rule_name}
                    className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-4 left-4">
                    <span
                      className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(
                        campaign.status
                      )}`}
                    >
                      <i className={`${getStatusIcon(campaign.status)} text-sm`}></i>
                      {campaign.status === '1' ? 'Active' : campaign.status?.charAt(0).toUpperCase() + campaign.status.slice(1)}
                    </span>
                  </div>
                  <div className="absolute top-4 right-4">
                    <Link
                      to={`/campaigns/edit/${campaign.rule_code}`}
                      className="w-10 h-10 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center text-gray-600 hover:text-blue-600 hover:bg-white transition-all duration-200 cursor-pointer shadow-lg"
                    >
                      <i className="ri-edit-line text-lg"></i>
                    </Link>
                  </div>
                </div>

                <div className="p-6">
                  <div className="mb-4">
                    <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-1">
                      {campaign.rule_name}
                    </h3>
                    <p className="text-gray-600 text-sm line-clamp-2 leading-relaxed">
                      {campaign.rule_description}
                    </p>
                  </div>

                  <div className="space-y-4">
                    <div className="flex items-center gap-2 text-sm">
                      <i className="ri-calendar-line text-gray-400 text-lg"></i>
                      <span className="text-gray-600">
                        <span className="font-medium">Ends</span>{' '}
                        {new Date(campaign.end_date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                        })}
                      </span>
                    </div>

                    <div className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-100">
                      <div className="text-center">
                        <p className="text-2xl font-bold text-gray-900">
                          {campaign.participate?.toLocaleString()|| 0} 
                        </p>
                        <p className="text-xs text-gray-500 font-medium">
                          Participants
                        </p>
                      </div>
                      <div className="text-center">
                        <p className="text-2xl font-bold text-gray-900">
                          {campaign.earn?.toLocaleString()||0}
                        </p>
                        <p className="text-xs text-gray-500 font-medium">
                          Points Earned
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Controls */}
          {filteredCampaigns.length > campaignsPerPage && (
            <div className="mt-8 flex justify-center items-center gap-2">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-4 py-2 rounded-lg ${
                  currentPage === 1
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-600 hover:bg-gray-50'
                } border border-gray-300 transition-colors`}
              >
                <i className="ri-arrow-left-s-line"></i>
              </button>

              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => paginate(index + 1)}
                  className={`px-4 py-2 rounded-lg border border-gray-300 transition-colors ${
                    currentPage === index + 1
                      ? 'bg-blue-600 text-white'
                      : 'bg-white text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {index + 1}
                </button>
              ))}

              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-4 py-2 rounded-lg ${
                  currentPage === totalPages
                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                    : 'bg-white text-gray-600 hover:bg-gray-50'
                } border border-gray-300 transition-colors`}
              >
                <i className="ri-arrow-right-s-line"></i>
              </button>
            </div>
          )}

          {filteredCampaigns.length === 0 && (
            <div className="text-center py-16">
              <div className="w-32 h-32 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-megaphone-line text-4xl text-gray-400"></i>
              </div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                No campaigns found
              </h3>
              <p className="text-gray-600 mb-8 max-w-md mx-auto">
                {searchTerm || filterStatus !== 'all'
                  ? "Try adjusting your search or filter criteria to find what you're looking for."
                  : 'Get started by creating your first loyalty campaign to engage your customers.'}
              </p>
              <Link
                to="/campaigns/create"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all duration-200 font-semibold shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-add-line text-lg"></i>
                Create New Campaign
              </Link>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}